export interface ITypeNameElement {
    type: string;
    name: string;
}

export function getElementNameByType(elementType: string, elements: ITypeNameElement[]) {
    if (elements != null) {
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].type === elementType) {
                return elements[i].name;
            }
        }
    }

    return null;
}

export function getElementTypeByName(elementName: string, elements: ITypeNameElement[]) {
    if (elements != null) {
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].name === elementName) {
                return elements[i].type;
            }
        }
    }

    return null;
}

export const NONE = 'none';
export const TEMPLATE_VALUE_KEY = 'cell-value';

export const ATTRIBUTE_TYPES = {
    BOOLEAN: 'b',
    DATE: 'date',
    DATETIME: 'datetime',
    TIME: 'time',
    STRING: 's',
    INTEGER: 'i',
    REAL: 'r',
    BIGINT: 'bigint',
    ENUMERATION: 'e',
    VARIABLE: 'variable',
    EXCHANGE_OBJECT: 'exchangeObject',
    LOGICAL: 'logical',
    ANYTYPE: 'anytype'
};

export const ATTRIBUTE_CONTROL_TYPES = {
    DROPDOWN: 'dropdown',
    LIST: 'list',
    TEXT: 'text',
    MULTILINE_TEXT: 'multiline_text',
    HTML: 'ckedit',
    JSON: 'json',
    SLIDER: 'slider',
    TREE: 'tree',
    BOOLEAN: 'boolean',
    DATETIME: 'datetime',
    DATE: 'date',
    TIME: 'time',
    NUMBER: 'number', //12.09.2019: Obsolete. Is considered as integer.
    INTEGER: 'integer',
    DECIMAL: 'decimal',
    JOINT_TABLE_LIST: 'jointTableList',
    EDIT_COMPONENT: 'component_'
};

export const AGGREGATIONS = {
    NONE: 'none',
    GROUP: 'group',
    COUNT: 'count',
    COUNT_DISTINCT: 'count distinct',
    COUNT_NOT_NULL: 'count not null',
    MIN: 'min',
    MAX: 'max',
    SUM: 'sum',
    SUM_DISTINCT: 'sum distinct',
    AVG: 'avg',
    AVG_DISTINCT: 'avg distinct',
    MEDIAN: 'median',
    STRING_AGG: 'string_agg',
    UNION: 'union'
};

export type AlignmentType = 'left' | 'center' | 'right'; //default: undefined  //LL: 18.01.21 from GridBase

// VR: do not rename here the names like "year", "weekday", etc because they are passed to backend
export const TIME_PART_TYPES = {
    NONE: 'none',
    YEAR: 'year',
    FISCAL_YEAR: 'yearFiscal',
    HALF_YEAR: 'halfyear',
    HALF_FISCAL_YEAR: 'halfYearFiscal',
    QUARTER: 'quarter',
    FISCAL_QUARTER: 'quarterFiscal',
    MONTH: 'month',
    WEEK: 'week',
    ISOWEEK: 'isoweek',
    DAY: 'day',
    DAY_OF_YEAR: 'dayofyear',
    DAY_OF_WEEK: 'weekday',
    HOUR: 'hour',
    MINUTE: 'minute',
    SECOND: 'second',
    MILLISECOND: 'millisecond'
};

export const TIME_PART_ELEMENTS: { [intervalType: string]: ITypeNameElement[] } = {
    dateInterval: [
        { type: TIME_PART_TYPES.NONE, name: 'None' },
        { type: TIME_PART_TYPES.YEAR, name: 'Year' },
        { type: TIME_PART_TYPES.FISCAL_YEAR, name: 'Fiscal Year' },
        { type: TIME_PART_TYPES.HALF_YEAR, name: 'Half Year' },
        { type: TIME_PART_TYPES.HALF_FISCAL_YEAR, name: 'Fiscal Half Year' },
        { type: TIME_PART_TYPES.QUARTER, name: 'Quarter' },
        { type: TIME_PART_TYPES.FISCAL_QUARTER, name: 'Fiscal Quarter' },
        { type: TIME_PART_TYPES.MONTH, name: 'Month' },
        { type: TIME_PART_TYPES.WEEK, name: 'Week' },
        { type: TIME_PART_TYPES.ISOWEEK, name: 'ISO Week' },
        { type: TIME_PART_TYPES.DAY_OF_WEEK, name: 'Day Of Week' },
        { type: TIME_PART_TYPES.DAY, name: 'Day Of Month' },
        { type: TIME_PART_TYPES.DAY_OF_YEAR, name: 'Day Of Year' }
    ],

    dateTimeInterval: [
        { type: TIME_PART_TYPES.NONE, name: 'None' },
        { type: TIME_PART_TYPES.YEAR, name: 'Year' },
        { type: TIME_PART_TYPES.FISCAL_YEAR, name: 'Fiscal Year' },
        { type: TIME_PART_TYPES.HALF_YEAR, name: 'Half Year' },
        { type: TIME_PART_TYPES.HALF_FISCAL_YEAR, name: 'Fiscal Half Year' },
        { type: TIME_PART_TYPES.QUARTER, name: 'Quarter' },
        { type: TIME_PART_TYPES.FISCAL_QUARTER, name: 'Fiscal Quarter' },
        { type: TIME_PART_TYPES.MONTH, name: 'Month' },
        { type: TIME_PART_TYPES.WEEK, name: 'Week' },
        { type: TIME_PART_TYPES.ISOWEEK, name: 'ISO Week' },
        { type: TIME_PART_TYPES.DAY_OF_WEEK, name: 'Day Of Week' },
        { type: TIME_PART_TYPES.DAY, name: 'Day Of Month' },
        { type: TIME_PART_TYPES.DAY_OF_YEAR, name: 'Day Of Year' },
        { type: TIME_PART_TYPES.HOUR, name: 'Hour' },
        { type: TIME_PART_TYPES.MINUTE, name: 'Minute' },
        { type: TIME_PART_TYPES.SECOND, name: 'Second' },
        { type: TIME_PART_TYPES.MILLISECOND, name: 'Millisecond' }
    ],

    timeInterval: [
        { type: TIME_PART_TYPES.NONE, name: 'None' },
        { type: TIME_PART_TYPES.HOUR, name: 'Hour' },
        { type: TIME_PART_TYPES.MINUTE, name: 'Minute' },
        { type: TIME_PART_TYPES.SECOND, name: 'Second' },
        { type: TIME_PART_TYPES.MILLISECOND, name: 'Millisecond' }
    ]
};

export const TIME_INTERVAL_ELEMENTS = {
    dateInterval: [
        {
            type: 'none',
            name: 'None',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'year',
            name: 'Year',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'quarter',
            name: 'Quarter',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'month',
            name: 'Month',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'week',
            name: 'Week',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'day',
            name: 'Day',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        }
    ],

    dateTimeInterval: [
        {
            type: 'none',
            name: 'None',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'year',
            name: 'Year',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'quarter',
            name: 'Quarter',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'month',
            name: 'Month',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'week',
            name: 'Week',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'day',
            name: 'Day',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'hour',
            name: 'Hour',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'minute',
            name: 'Minute',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'second',
            name: 'Second',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'millisecond',
            name: 'Millisecond',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        }
    ],

    timeInterval: [
        {
            type: 'none',
            name: 'None',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'hour',
            name: 'Hour',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'minute',
            name: 'Minute',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'second',
            name: 'Second',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        },
        {
            type: 'millisecond',
            name: 'Millisecond',
            num: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45, 50, 60, 70,
                80, 90, 100, 200, 300, 400, 500
            ]
        }
    ]
};

export const TIME_PERIOD_ELEMENTS: { [intervalType: string]: ITypeNameElement[] } = {
    timePeriods: [
        { type: 'none', name: 'None' },
        { type: 'year', name: 'Year' },
        { type: TIME_PART_TYPES.FISCAL_YEAR, name: 'Fiscal Year' },
        { type: 'halfYear', name: 'Half Year' },
        { type: 'halfYearFiscal', name: 'Fiscal Half Year' },
        { type: 'quarter', name: 'Quarter' },
        { type: 'quarterFiscal', name: 'Fiscal Quarter' },
        { type: 'month', name: 'Month' },
        { type: 'week', name: 'Week' },
        { type: 'isoweek', name: 'ISO Week' },
        { type: 'day', name: 'Day' },
        { type: 'hour', name: 'Hour' },
        { type: 'minute', name: 'Minute' },
        { type: 'second', name: 'Second' }
    ],

    timePeriodsOnlyDate: [
        { type: 'none', name: 'None' },
        { type: 'year', name: 'Year' },
        { type: TIME_PART_TYPES.FISCAL_YEAR, name: 'Fiscal Year' },
        { type: 'halfYear', name: 'Half Year' },
        { type: 'halfYearFiscal', name: 'Fiscal Half Year' },
        { type: 'quarter', name: 'Quarter' },
        { type: 'quarterFiscal', name: 'Fiscal Quarter' },
        { type: 'month', name: 'Month' },
        { type: 'week', name: 'Week' },
        { type: 'isoweek', name: 'ISO Week' },
        { type: 'day', name: 'Day' }
    ],

    timePeriodsOnlyTime: [
        { type: 'none', name: 'None' },
        { type: 'hour', name: 'Hour' },
        { type: 'minute', name: 'Minute' },
        { type: 'second', name: 'Second' }
    ],

    timePeriodPoints: [
        { type: 'start', name: 'Start' },
        { type: 'middle', name: 'Middle' },
        { type: 'end', name: 'End' }
    ],

    timePeriodPointDefault: [{ type: 'middle', name: 'middle' }]
};

//export type AttributeControlType = 'dropdown' | 'list' | 'text' | 'slider' | 'tree' | 'number' | 'boolean' | 'datetime' | 'date' | 'time';

// When changing here look at VALID_ATTRIBUTE_CONTROL_TYPES.
export const VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES: {
    [attributeType: string]: ITypeNameElement[];
} = {
    e: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TEXT,
            name: 'Input'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TREE,
            name: 'Tree'
        }
    ],

    s: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TEXT,
            name: 'Input'
        }
    ],

    i: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.INTEGER,
            name: 'Input'
        }
    ],

    r: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DECIMAL,
            name: 'Input'
        }
    ],

    b: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.BOOLEAN,
            name: 'Input'
        }
    ],

    datetime: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DATETIME,
            name: 'Input'
        }
    ],

    date: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DATE,
            name: 'Input'
        }
    ],

    time: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TIME,
            name: 'Input'
        }
    ],

    variable: [
        {
            type: ATTRIBUTE_CONTROL_TYPES.BOOLEAN,
            name: 'Boolean'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DATE,
            name: 'Date'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DATETIME,
            name: 'DateTime'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TIME,
            name: 'Time'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.INTEGER,
            name: 'Integer'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DECIMAL,
            name: 'Decimal'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TEXT,
            name: 'String'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.DROPDOWN,
            name: 'Dropdown'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.TREE,
            name: 'Tree'
        }
    ]
};

// When changing here look at VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES.
export const VALID_ATTRIBUTE_CONTROL_TYPES: {
    [attributeType: string]: ITypeNameElement[];
} = {
    e: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.ENUMERATION]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.LIST,
            name: 'List'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    s: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.STRING]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.LIST,
            name: 'List'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    i: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.INTEGER]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    r: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.REAL]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    b: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.BOOLEAN]],

    datetime: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.DATETIME]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    date: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.DATE]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    time: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.TIME]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        }
    ]),

    variable: [...VALID_LOCAL_FILTER_ATTRIBUTE_CONTROL_TYPES[ATTRIBUTE_TYPES.VARIABLE]].concat([
        {
            type: ATTRIBUTE_CONTROL_TYPES.SLIDER,
            name: 'Value Slider'
        },
        {
            type: ATTRIBUTE_CONTROL_TYPES.LIST,
            name: 'List'
        }
    ])
};

const ALL_TITLE = 'All';
const VALID_ONLY_TITLE = 'Only the Values Filtered by the other Selections';
const ALL_AND_VALID_FIRST_TITLE = 'All where Filtered Values are shown first';

export const ATTRIBUTE_VALUE_SHOWING_TYPES: {
    [showingType: string]: ITypeNameElement[];
} = {
    dropdown: [
        {
            type: 'all',
            name: ALL_TITLE
        },
        {
            type: 'valid',
            name: VALID_ONLY_TITLE
        },
        {
            type: 'suggesting',
            name: ALL_AND_VALID_FIRST_TITLE
        }
    ],

    list: [
        {
            type: 'all',
            name: ALL_TITLE
        },
        {
            type: 'valid',
            name: VALID_ONLY_TITLE
        },
        {
            type: 'suggesting',
            name: ALL_AND_VALID_FIRST_TITLE
        }
    ],

    slider: [
        {
            type: 'all',
            name: ALL_TITLE
        },
        {
            type: 'valid',
            name: VALID_ONLY_TITLE
        }
    ],

    tree: [
        {
            type: 'all',
            name: ALL_TITLE
        },
        {
            type: 'valid',
            name: VALID_ONLY_TITLE
        }
    ]
};

export const COLOR_MAP_UNDEF_KEY = '<no value>'; // '__undefined';  //LL: 20.05.17
export const COLOR_MAP_UNDEF_COLOR = '#aaaaaa'; // '#000000';  // 'black';  //LL: 02.03.20

export interface IValueNameElement {
    value: string;
    name: string;
}

export interface IFormatElement extends IValueNameElement {
    title?: string;
    timeInterval?: boolean;
}

export const TIME_PART_FORMATS = {
    FOUR_DIGITS: '4digits',
    TWO_DIGITS: '2digits',
    LONG_FISCAL_YEAR: 'longYearFiscal',
    SHORT_FISCAL_YEAR: 'shortYearFiscal',
    LONG_FISCAL_YEAR_START_END: 'longFiscalYearStartEnd',
    SHORT_FISCAL_YEAR_START_END: 'shortFiscalYearStartEnd'
};

export const FORMATS: { [type: string]: IFormatElement[] } = {
    b: [
        { value: 'YesNo', name: 'Yes/No' },
        { value: 'YesEmpty', name: 'Yes/Empty' },
        { value: 'TrueFalse', name: 'True/False' },
        { value: 'number', name: '1/0' },
        { value: 'Checkbox', name: 'Checkbox' },
        { value: 'custom', name: 'custom', title: 'Custom Format' }
    ],

    i: [
        {
            value: 'decimal',
            name: 'decimal',
            title: 'displays a value as an integer with an optional negative sign'
        },
        {
            value: 'decimal largeNumber',
            name: 'decimal large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal thousands',
            name: 'decimal thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal millions',
            name: 'decimal millions',
            title: "a value is divided by one million, the letter 'M' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal billions',
            name: 'decimal billions',
            title: "a value is divided by one billion, the letter 'B' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal trillions',
            name: 'decimal trillions',
            title: "a value is divided by one trillion, the letter added and the 'decimal' format is applied"
        },
        {
            value: 'largeNumber',
            name: 'large number',
            title: " a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied"
        },
        {
            value: 'percent',
            name: 'percent',
            title: 'a value is multiplied percent symbol'
        },
        {
            value: 'exponential',
            name: 'exponential',
            title: 'displays a value with an exponential notation'
        },
        {
            value: 'currency',
            name: 'currency',
            title: 'displays a value as currency'
        },
        {
            value: 'currency largeNumber',
            name: 'currency large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'currency' format is applied"
        },
        {
            value: 'currency thousands',
            name: 'currency thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'currency' format is applied"
        },
        {
            value: 'currency millions',
            name: 'currency millions',
            title: "a value is divided by one million, the letter 'M' is added and the 'currency' format is applied"
        },
        {
            value: 'currency billions',
            name: 'currency billions',
            title: "a value is divided by one billions, the letter 'B' is added and the 'currency' format is applied"
        },
        {
            value: 'currency trillions',
            name: 'currency trillions',
            title: "a value is divided by one trillion, the letter added and the 'currency' format is applied"
        },

        //  TimeParts:
        { value: 'longYear', name: 'long year', title: 'e.g. 1915' },
        { value: 'shortYear', name: 'short year', title: 'e.g. 15' },
        {
            value: TIME_PART_FORMATS.LONG_FISCAL_YEAR,
            name: 'long year fiscal',
            title: 'e.g. 1915F'
        },
        {
            value: TIME_PART_FORMATS.SHORT_FISCAL_YEAR,
            name: 'short year fiscal',
            title: 'e.g. 15F'
        },
        {
            value: TIME_PART_FORMATS.LONG_FISCAL_YEAR_START_END,
            name: "long fiscal year's start-end",
            title: 'e.g. FY2022-2023'
        },
        {
            value: TIME_PART_FORMATS.SHORT_FISCAL_YEAR_START_END,
            name: "short fiscal year's start-end",
            title: 'e.g. FY22-23'
        },
        {
            value: 'longHalfYear',
            name: 'long half year',
            title: 'e.g. 1st Half'
        },
        { value: 'shortHalfYear', name: 'short half year', title: 'e.g. 1st' },
        {
            value: 'longHalfYearFiscal',
            name: 'long half year fiscal',
            title: 'e.g. 1st Half F'
        },
        {
            value: 'shortHalfYearFiscal',
            name: 'short half year fiscal',
            title: 'e.g. 1st F'
        },
        { value: 'Q', name: 'Q + number (for date)', title: 'quarter' },
        { value: 'latin', name: 'latin (for date)', title: 'quarter' },
        { value: 'Qlatin', name: 'Q + latin (for date)', title: 'quarter' },
        { value: 'Q_N', name: 'Q + number (for quarter)', title: 'quarter' },
        { value: 'latin_N', name: 'latin (for quarter)', title: 'quarter' },
        {
            value: 'Qlatin_N',
            name: 'Q + latin (for quarter)',
            title: 'quarter'
        },
        {
            value: 'Q_Fiscal',
            name: 'Q + number (for fiscal quarter)',
            title: 'fiscal quarter'
        },
        {
            value: 'latin_Fiscal',
            name: 'latin (for fiscal quarter)',
            title: 'fiscal quarter'
        },
        {
            value: 'Qlatin_Fiscal',
            name: 'Q + latin (for fiscal quarter)',
            title: 'fiscal quarter'
        },
        { value: 'shortMonth', name: 'short month', title: 'e.g. Apr' },
        { value: 'longMonth', name: 'long month', title: 'e.g. April' },
        { value: 'monthNumber', name: 'month number', title: 'e.g. 04' },
        { value: 'shortweekDay', name: 'short Week Day', title: 'e.g. Mon' },
        { value: 'longweekDay', name: 'long Week Day', title: 'e.g. Monday' },
        { value: 'minWeekDay', name: 'min Week Day', title: 'e.g. Mn' },
        { value: 'weekDayNumber', name: 'Week Day Number', title: 'e.g. 2' },

        { value: 'Days', name: 'days', title: 'Days from Seconds' },
        { value: 'Hours', name: 'hours', title: 'Hours from Seconds' },
        { value: 'Minutes', name: 'minutes', title: 'Minutes from Seconds' },
        { value: 'Seconds', name: 'seconds', title: 'Seconds' },

        //LL 22.12.19: also add TimeIntervals formats from "r": "Hours HH:MM", "Hours HH:MM:SS", "Minutes MM:SS", "Minutes HH:MM:SS"
        {
            value: 'Hours DD:HH',
            name: 'hours DD:HH',
            title: 'value as hours DD:HH',
            timeInterval: true
        },
        {
            value: 'Hours HH:MM',
            name: 'hours HH:MM',
            title: 'value as hours HH:MM',
            timeInterval: true
        },
        {
            value: 'Hours HH:MM:SS',
            name: 'hours HH:MM:SS',
            title: 'value as hours HH:MM:SS',
            timeInterval: true
        },
        {
            value: 'Minutes DD:HH:MM',
            name: 'minutes DD:HH:MM',
            title: 'value as minutes DD:HH:MM',
            timeInterval: true
        },
        {
            value: 'Minutes HH:MM',
            name: 'minutes HH:MM',
            title: 'value as minutes HH:MM',
            timeInterval: true
        },
        {
            value: 'Minutes MM:SS',
            name: 'minutes MM:SS',
            title: 'value as minutes MM:SS',
            timeInterval: true
        },
        {
            value: 'Minutes HH:MM:SS',
            name: 'minutes HH:MM:SS',
            title: 'value as minutes HH:MM:SS',
            timeInterval: true
        },
        {
            value: 'Seconds MM:SS',
            name: 'seconds MM:SS',
            title: 'value as seconds MM:SS',
            timeInterval: true
        },
        {
            value: 'Seconds HH:MM:SS',
            name: 'seconds HH:MM:SS',
            title: 'value as seconds HH:MM:SS',
            timeInterval: true
        },
        //LL: why not use format  "largeNumber" ?   Leo wants
        //{ value: "LargeMinutes", name: "large minutes", title: " a value is divided by a number (one thousand, one million, one billion or one trillion)
        //so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied", timeInterval: true }, //LL 22.12.19  Large Mins
        { value: 'custom', name: 'custom', title: 'Custom Format' }
    ],

    r: [
        {
            value: 'fixedPoint',
            name: 'fixed point',
            title: 'displays a specified number of digits for the fractional part and an optional negative sign'
        },
        {
            value: 'fixedPoint largeNumber',
            name: 'fixed point large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'fixedPoint' format is applied"
        },
        {
            value: 'fixedPoint thousands',
            name: 'fixed point thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'fixedPoint' format is applied"
        },
        {
            value: 'fixedPoint millions',
            name: 'fixed point millions',
            title: "a value is divided by one million, the letter 'M' added and the 'fixedPoint' format is applied"
        },
        {
            value: 'fixedPoint billions',
            name: 'fixed point billions',
            title: "a value is divided by one billion, the letter 'B' is added and the 'fixedPoint' format is applied"
        },
        {
            value: 'fixedPoint trillions',
            name: 'fixed point trillions',
            title: "a value is divided by one trillion, the letter 'T' is added and the 'fixedPoint' format is applied"
        },
        {
            value: 'largeNumber',
            name: 'large number',
            title: " a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied"
        },
        {
            value: 'percent',
            name: 'percent',
            title: 'a value is multiplied percent symbol'
        },
        {
            value: 'exponential',
            name: 'exponential',
            title: 'displays a value with an exponential notation'
        },
        {
            value: 'currency',
            name: 'currency',
            title: 'displays a value as currency'
        },
        {
            value: 'currency largeNumber',
            name: 'currency large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'currency' format is applied"
        },
        {
            value: 'currency thousands',
            name: 'currency thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'currency' format is applied"
        },
        {
            value: 'currency millions',
            name: 'currency millions',
            title: "a value is divided by one million, the letter 'M' is added and the 'currency' format is applied"
        },
        {
            value: 'currency billions',
            name: 'currency billions',
            title: "a value is divided by one billion, the letter 'B' is added and the 'currency' format is applied"
        },
        {
            value: 'currency trillions',
            name: 'currency trillions',
            title: "a value is divided by one trillion, the letter added and the 'currency' format is applied"
        },

        {
            value: 'timeInterval',
            name: 'time interval',
            title: 'a value is displayed as time period: hh:mm',
            timeInterval: true
        },
        //LL 22.12.19: add TimeIntervals formats from "i": "Hours DD:HH", "Minutes DD:HH:MM", "Minutes HH:MM", "Seconds MM:SS", "Seconds HH:MM:SS"
        {
            value: 'Hours DD:HH',
            name: 'hours DD:HH',
            title: 'value as hours DD:HH',
            timeInterval: true
        },
        {
            value: 'Hours HH:MM',
            name: 'hours HH:MM',
            title: 'value as hours HH:MM',
            timeInterval: true
        },
        {
            value: 'Hours HH:MM:SS',
            name: 'hours HH:MM:SS',
            title: 'value as hours HH:MM:SS',
            timeInterval: true
        },
        {
            value: 'Minutes DD:HH:MM',
            name: 'minutes DD:HH:MM',
            title: 'value as minutes DD:HH:MM',
            timeInterval: true
        },
        {
            value: 'Minutes HH:MM',
            name: 'minutes HH:MM',
            title: 'value as minutes HH:MM',
            timeInterval: true
        },
        {
            value: 'Minutes MM:SS',
            name: 'minutes MM:SS',
            title: 'value as minutes MM:SS',
            timeInterval: true
        },
        {
            value: 'Minutes HH:MM:SS',
            name: 'minutes HH:MM:SS',
            title: 'value as minutes HH:MM:SS',
            timeInterval: true
        },
        {
            value: 'Seconds MM:SS',
            name: 'seconds MM:SS',
            title: 'value as seconds MM:SS',
            timeInterval: true
        },
        {
            value: 'Seconds HH:MM:SS',
            name: 'seconds HH:MM:SS',
            title: 'value as seconds HH:MM:SS',
            timeInterval: true
        },

        { value: 'custom', name: 'custom', title: 'Custom Format' }
    ],
    count: [
        {
            value: 'decimal',
            name: 'decimal',
            title: 'displays a value as an integer with an optional negative sign'
        },
        {
            value: 'decimal largeNumber',
            name: 'decimal large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal thousands',
            name: 'decimal thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal millions',
            name: 'decimal millions',
            title: "a value is divided by one million, the letter 'M' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal billions',
            name: 'decimal billions',
            title: "a value is divided by one billion, the letter 'B' is added and the 'decimal' format is applied"
        },
        {
            value: 'decimal trillions',
            name: 'decimal trillions',
            title: "a value is divided by one trillion, the letter added and the 'decimal' format is applied"
        },
        {
            value: 'largeNumber',
            name: 'large number',
            title: " a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'decimal' format is applied"
        },
        {
            value: 'percent',
            name: 'percent',
            title: 'a value is multiplied percent symbol'
        },
        {
            value: 'exponential',
            name: 'exponential',
            title: 'displays a value with an exponential notation'
        },
        {
            value: 'currency',
            name: 'currency',
            title: 'displays a value as currency'
        },
        {
            value: 'currency largeNumber',
            name: 'currency large number',
            title: "a value is divided by a number (one thousand, one million, one billion or one trillion) so that the value is less than a thousand; then letter 'K', 'M', 'B' or 'T' is added and the 'currency' format is applied"
        },
        {
            value: 'currency thousands',
            name: 'currency thousands',
            title: "a value is divided by one thousand, the letter 'K' is added and the 'currency' format is applied"
        },
        {
            value: 'currency millions',
            name: 'currency millions',
            title: "a value is divided by one million, the letter 'M' is added and the 'currency' format is applied"
        },
        {
            value: 'currency billions',
            name: 'currency billions',
            title: "a value is divided by one billion, the letter 'B' is added and the 'currency' format is applied"
        },
        {
            value: 'currency trillions',
            name: 'currency trillions',
            title: "a value is divided by one trillion, the letter added and the 'currency' format is applied"
        },
        { value: 'custom', name: 'custom', title: 'Custom Format' }
    ],
    not_set: []
};

export const TIME_PART_FORMAT_ELEMENTS: { [timePart: string]: IFormatElement[] } = {
    year: [
        { value: TIME_PART_FORMATS.FOUR_DIGITS, name: '4 Digits' },
        { value: TIME_PART_FORMATS.TWO_DIGITS, name: '2 Digits' }
    ],
    yearFiscal: [
        { value: TIME_PART_FORMATS.FOUR_DIGITS, name: '4 Digits' },
        { value: TIME_PART_FORMATS.TWO_DIGITS, name: '2 Digits' },
        { value: TIME_PART_FORMATS.LONG_FISCAL_YEAR, name: 'Long Fiscal Year' },
        { value: TIME_PART_FORMATS.SHORT_FISCAL_YEAR, name: 'Short Fiscal Year' },
        { value: TIME_PART_FORMATS.LONG_FISCAL_YEAR_START_END, name: "Long Fiscal Year's start-end" },
        { value: TIME_PART_FORMATS.SHORT_FISCAL_YEAR_START_END, name: "Short Fiscal Year's start-end" }
    ],
    halfyear: [
        { value: 'longHalfYear', name: 'Long Half Year' },
        { value: 'shortHalfYear', name: 'Short Half Year' }
    ],
    halfYearFiscal: [
        { value: 'longHalfYear', name: 'Long Half Year' },
        { value: 'shortHalfYear', name: 'Short Half Year' },
        { value: 'longHalfYearFiscal', name: 'Long Fiscal Half Year' },
        { value: 'shortHalfYearFiscal', name: 'Short Fiscal Half Year' }
    ],
    quarter: [
        { value: 'Q', name: 'Q + number' },
        { value: 'latin', name: 'latin' },
        { value: 'Qlatin', name: 'Q + latin' }
    ],
    quarterFiscal: [
        { value: 'Q', name: 'Q + number' },
        { value: 'latin', name: 'latin' },
        { value: 'Qlatin', name: 'Q + latin' },
        { value: 'Q_Fiscal', name: 'Q + fiscal number' },
        { value: 'latin_Fiscal', name: 'fiscal latin' },
        { value: 'Qlatin_Fiscal', name: 'Q + fiscal latin' }
    ],
    month: [
        { value: 'longName', name: 'longName' },
        { value: 'shortName', name: 'shortName' },
        //{ value: "longMonth", name: "longMonth" },
        //{ value: "shortMonth", name: "shortMonth" },
        { value: 'numbers', name: 'numbers' }
    ],
    weekday: [
        { value: 'longName', name: 'longName' },
        { value: 'shortName', name: 'shortName' },
        { value: 'minName', name: 'minName' },
        //{ value: "longweekDay", name: "longweekDay" },
        //{ value: "shortweekDay", name: "shortweekDay" },
        //{ value: "minweekDay", name: "minweekDay" },
        { value: 'numbers', name: 'numbers' }
    ],
    type_time: [
        { value: 'longTime', name: 'longTime' },
        { value: 'shortTime', name: 'shortTime' },
        { value: 'HH', name: 'hour' },
        { value: 'mm', name: 'minute' },
        { value: 'ss', name: 'second' },
        { value: 'millisecond', name: 'millisecond' },
        { value: 'custom', name: 'custom' }
    ],
    type_date_only: [
        { value: 'longDate', name: 'longDate' },
        { value: 'shortDate', name: 'shortDate' },
        { value: 'monthAndDay', name: 'monthAndDay' },
        { value: 'monthAndYear', name: 'monthAndYear' },
        { value: 'quarterAndYear', name: 'quarterAndYear' },
        { value: 'year', name: 'year' },
        { value: 'halfyear', name: 'halfyear' },
        { value: 'quarter', name: 'quarter' },
        { value: 'month', name: 'month' },
        { value: 'day', name: 'day' },
        { value: 'custom', name: 'custom' } //VR, WI 113392
    ],
    hour: [{ value: 'custom', name: 'custom' }],
    minute: [{ value: 'custom', name: 'custom' }],
    second: [{ value: 'custom', name: 'custom' }],
    not_set: [],
    default: [
        { value: 'dateLongTime', name: 'dateLongTime' },
        { value: 'longDateLongTime', name: 'longDateLongTime' },
        { value: 'dateShortTime', name: 'dateShortTime' },
        { value: 'longDate', name: 'longDate' },
        { value: 'longTime', name: 'longTime' },
        { value: 'monthAndDay', name: 'monthAndDay' },
        { value: 'monthAndYear', name: 'monthAndYear' },
        { value: 'quarterAndYear', name: 'quarterAndYear' },
        { value: 'shortDate', name: 'shortDate' },
        { value: 'shortTime', name: 'shortTime' },
        { value: 'year', name: 'year' },
        { value: 'halfyear', name: 'halfyear' },
        { value: 'quarter', name: 'quarter' },
        { value: 'month', name: 'month' },
        { value: 'day', name: 'day' },
        { value: 'HH', name: 'hour' },
        { value: 'mm', name: 'minute' },
        { value: 'ss', name: 'second' },
        { value: 'millisecond', name: 'millisecond' },
        { value: 'custom', name: 'custom' }
    ]
};
